"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var __1 = tslib_1.__importDefault(require(".."));
var SSPAssetDataSetAccessor_1 = tslib_1.__importDefault(require("./accessor/SSPAssetDataSetAccessor"));
var SSPAssetFolderAccessor_1 = tslib_1.__importDefault(require("./accessor/SSPAssetFolderAccessor"));
var SSPBaseDataAccessor_1 = tslib_1.__importDefault(require("./accessor/SSPBaseDataAccessor"));
var SSPContentFieldAccessor_1 = tslib_1.__importDefault(require("./accessor/SSPContentFieldAccessor"));
var SSPContentVO = (function (_super) {
    tslib_1.__extends(SSPContentVO, _super);
    function SSPContentVO(uid) {
        var _this = _super.call(this, { Uid: uid }) || this;
        _this._contentFieldAccessor = null;
        _this._assetFolderAccessor = null;
        _this._assetDataSetAccessor = null;
        return _this;
    }
    SSPContentVO.prototype.applyJson = function (jsonObj) {
        this._acc.target = jsonObj;
        if (this.isAsset) {
            if (!this._assetDataSetAccessor) {
                this._assetDataSetAccessor = new SSPAssetDataSetAccessor_1.default(this);
            }
            else {
                this._assetDataSetAccessor.update(this);
            }
        }
        else if (this.isFolder) {
            if (!this._assetFolderAccessor) {
                this._assetFolderAccessor = new SSPAssetFolderAccessor_1.default(this);
            }
            else {
                this._assetFolderAccessor.update(this);
            }
        }
        else {
            if (!this._contentFieldAccessor) {
                this._contentFieldAccessor = new SSPContentFieldAccessor_1.default(this);
            }
            else {
                this._contentFieldAccessor.update(this);
            }
        }
        return this;
    };
    SSPContentVO.prototype.applyModel = function (model) {
        this.applyJson(model._acc.target);
    };
    Object.defineProperty(SSPContentVO.prototype, "asAsset", {
        get: function () {
            if (!this._assetDataSetAccessor) {
                this._assetDataSetAccessor = new SSPAssetDataSetAccessor_1.default(this);
            }
            return this._assetDataSetAccessor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPContentVO.prototype, "asFolder", {
        get: function () {
            if (!this._assetFolderAccessor) {
                this._assetFolderAccessor = new SSPAssetFolderAccessor_1.default(this);
            }
            return this._assetFolderAccessor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPContentVO.prototype, "asModel", {
        get: function () {
            if (!this._contentFieldAccessor) {
                this._contentFieldAccessor = new SSPContentFieldAccessor_1.default(this);
            }
            return this._contentFieldAccessor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPContentVO.prototype, "exists", {
        get: function () {
            return __1.default.instance.modelExists(this.uid);
        },
        enumerable: false,
        configurable: true
    });
    SSPContentVO.prototype.getCopyForLang = function (lcOrLccc, cc) {
        var model = this.getCopy();
        model.setLanguage(lcOrLccc, cc);
        return model;
    };
    SSPContentVO.prototype.getCopy = function () {
        var model = new SSPContentVO(this.uid);
        model.applyModel(this);
        return model;
    };
    SSPContentVO.prototype.toString = function () {
        return "[" + this.uid + " SSPContentVO]";
    };
    return SSPContentVO;
}(SSPBaseDataAccessor_1.default));
exports.default = SSPContentVO;
